
<main>
    <section class="design-area" id="service">
        <div class="container">
            <div class="row">
                <div class="col-xl-12 text-center">
                    <div class="section-title ">
                        <h4>Digital Visiting Card</h4>
                        <h1>Digital Card View</h1>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center digital-cards" *ngIf="user">
                <div class="col-xl-4  col-md-12 mt-5" *ngFor="let color of colors">
                    <div class="" style="padding: 0px;">
                        <div class="page-container">
                            <div class="header">
                                <div class="company-section" [style]="{'background-color': color}">
                                    <img lazyLoad="{{user.company.logo}}" alt="User image" class="img-fluid company-logo">
                                    <p class="text-center company-name">{{user.company.name}}</p>
                                </div>
                                <div class="profile">
                                    <div class="row">
                                        <div class="col-12">
                                            <img lazyLoad="{{user.profile}}" alt="User image"
                                                class="img-fluid pfp">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="name_tit_bann_item" [style]="{'background-color': color}">
                                        <div style="margin-top: 70px;">
                                            <p class="text-center m-0" class="name_tit_text">{{user.name}}</p>
                                            <p class="text-center" class="name_tit_text_dec">{{user.post_detail.designation}}</p>
                                        </div>
                                        <div class="address-section-inner">
                                            <p>Address</p>
                                            <p class="name_tit_bann_item_sub">{{user.company.address}},{{user.company.city}},{{user.company.state.state}},{{user.company.country.country}}</p>
                                        </div>
                                        <div class="text-center contact-info">
                                            <p class=" "><span><img lazyLoad="../../../assets/img/digital_whatsapp.png"
                                                        alt="" class="img-fluid"></span>Whatsapp</p>
                                            <p class="  "><span><img lazyLoad="../../../assets/img/digital_call.png" alt=""
                                                        class="img-fluid"></span>Call</p>
                                            <p class=""><span><img lazyLoad="../../../assets/img/digital_email.png" alt=""
                                                        class="img-fluid"></span>Email</p>
                                            <p class=""><span><img lazyLoad="../../../assets/img/digital_website.png" alt=""
                                                        class="img-fluid"></span>Website</p>
                                        </div>
                                        <div class="text-center contact-info">
                                            <p class=" "><span><img lazyLoad="assets/img/digi_cata.png"
                                                        alt="" class="img-fluid"></span>Catalogue</p>
                                            <p class="  "><span><img lazyLoad="assets/img/digi_gallary.png" alt=""
                                                        class="img-fluid"></span>Product Gallery</p>
                                            <p class=""><span><img lazyLoad="assets/img/digi_about.png" alt=""
                                                        class="img-fluid"></span>About Us</p>
                                        </div>
                                        <div class="text-center contact-info contact-info-soc">
                                            <h5>Share in Social Media</h5>
                                            <p class=" "><span><a [href]="whatsapp" target="_blank"
                                                        data-action="share/whatsapp/share"><i
                                                            class="fa fa-whatsapp fa-2x"
                                                            aria-hidden="true"></i></a></span></p>
                                            <p class="  "><span><a [href]="facebook" target="_blank"><i
                                                            class="fa fa-facebook fa-2x"
                                                            aria-hidden="true"></i></a></span></p>
                                            <p class=""><span><a [href]="twitter" target="_blank"><i
                                                            class="fa fa-twitter fa-2x"
                                                            aria-hidden="true"></i></a></span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <button
                                        (click)="chooseCard(color)"
                                        class="btn btn-primary m-2 gti_digi_ban {{color==selected?'btn-success':''}}"
                                    >
                                        {{color==selected?'View':'Select'}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- design area end -->
</main>